var DesignTool = require('./design_tool/designtool');
module.exports = exports = DesignTool;
